import { redirectToInteractiveLogin } from "./interactiveLogin";

/**
 * Handle a 401 Unauthorized error from an API call.
 * Triggers an interactive login redirect, returning the user to the current URL.
 */
export function handle401Error(currentPath?: string): void {
  if (typeof window === "undefined") return;

  const returnTo = currentPath ?? `${window.location.pathname}${window.location.search}`;
  void redirectToInteractiveLogin(returnTo).catch(() => undefined);
}

